import { useState } from 'react';
import { ENV_CONFIG } from 'config/environment';
import { ButtonBrand } from 'components/ButtonBrand';
import { FadeContainer, FadeText } from 'components/CustomAnimations';
import { FEDERAL, LOCAL, STATE } from './constants';

export const RealResults = () => {
  const [selected, setSelected] = useState(LOCAL);
  const imagesList = {
    [LOCAL]: 'donation-page.jpg',
    [STATE]: 'community-page.jpg',
    [FEDERAL]: 'event-page.jpg',
  }; //TODO: Change to actual graphics

  return (
    <div className="real-results-header">
      <div className="real-results-title">
        <FadeText className="eyebrow-text" text="Real Results" progressive inViewTrigger />
        <FadeText
          progressive
          inViewTrigger
          delay={0.2}
          className="h2-dtm"
          text="In 2024, Oath donors helped break the Republican supermajority in North Carolina."
        />
        <FadeText
          inViewTrigger
          delay={0.8}
          className="h4-text"
          text="Dante Pittman won his race by just 871 votes. Oath donors accounted for nearly 30% of his total individual donors."
        />
        <FadeContainer className="real-results-buttons" inViewTrigger delay={0.4}>
          <ButtonBrand
            disabled={selected === LOCAL}
            $secondary={selected === LOCAL}
            onClick={() => setSelected(LOCAL)}
          >
            Local
          </ButtonBrand>
          <ButtonBrand
            disabled={selected === STATE}
            $secondary={selected === STATE}
            onClick={() => setSelected(STATE)}
          >
            State
          </ButtonBrand>
          <ButtonBrand
            disabled={selected === FEDERAL}
            $secondary={selected === FEDERAL}
            onClick={() => setSelected(FEDERAL)}
          >
            Federal
          </ButtonBrand>
        </FadeContainer>
      </div>
      <FadeContainer inViewTrigger delay={0.2}>
        <img
          src={`${ENV_CONFIG().CLOUD_STORAGE.URL}/static_content/${imagesList[selected]}`}
          alt="Candidate"
        />
      </FadeContainer>
    </div>
  );
};
